const KEY = "dh_broker_desk";

export const BROKER_DESK = {
  mine: "mine",
  office: "office",
};

export function getBrokerDesk() {
  try {
    return localStorage.getItem(KEY) === BROKER_DESK.mine ? BROKER_DESK.mine : BROKER_DESK.office;
  } catch {
    return BROKER_DESK.office;
  }
}

export function setBrokerDesk(mode) {
  const next = mode === BROKER_DESK.mine ? BROKER_DESK.mine : BROKER_DESK.office;
  localStorage.setItem(KEY, next);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("dh-broker-desk"));
  }
  return next;
}

export function recordAgentId(row) {
  return row?.agent_id || row?.agentId || "";
}

export function filterByBrokerDesk(rows, session, mode) {
  if (!Array.isArray(rows) || !session?.userId) return rows || [];
  if (session.role !== "broker" && session.role !== "admin") return rows;
  const id = session.userId;
  if (mode === BROKER_DESK.mine) {
    return rows.filter((row) => recordAgentId(row) === id);
  }
  return rows.filter((row) => {
    const agentId = recordAgentId(row);
    return agentId && agentId !== id;
  });
}
